module.exports = __webpack_public_path__ + "static/img/node.adf31750.png";